import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrDatePicker from '../components/FrDatePicker'
import AutoComp from '../components/AutoComp'
import FooterDelphus from '../components/FooterDelphus'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Documentos(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [cli, setCli] = useState()
  const [comboCli, setComboCli] = useState([{ value: '', display: '' }])
  const [comboAtivo, setComboAtivo] = useState([{ value: 'S', display: 'Ativo' }, { value: 'N', display: 'Inativo' },])


  const columns = [
    { id: 'formatdata', numeric: false, label: 'Data', align: 'left', minWidth: 200 },
    { id: 'nome', numeric: false, label: 'Cliente', align: 'left', minWidth: 150 },
    { id: 'fk_cto', numeric: false, label: 'Nº Contrato', align: 'left', minWidth: 200 },
    { id: 'descricao', numeric: false, label: 'Descrição', align: 'left', minWidth: 200 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setenableAdd(await api.getAcessos('Documentação Cliente', 'Inclusao'))
      setenableEdit(await api.getAcessos('Documentação Cliente', 'Alteracao'))
      setenableDel(await api.getAcessos('Documentação Cliente', 'Exclusao'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      if (query.fk_cli)
        setCli(query.fk_cli)
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const fetchCli = async () => {
      const auxValues = { ...filter };
      auxValues["fk_cli"] = cli;
      auxValues["nomecli"] = ''
      if (cli > 0) {
        await api.get("/clientes?pk_cli=" + cli).then((r) => {
          if (r.data[0]) {
            auxValues["nomecli"] = r.data[0].nome;

          }
        });
      }
      setFilter(auxValues);
    };
    fetchCli();
  }, [cli]);

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    queryObject.buscar = true
    setFiltered(true)
    window.history.replaceState({ filtered: true }, 'filter', "/salute/documentos?" + objectToQueryString(queryObject));
    swal.fire({
      html: <FrLoading text="Buscando dados..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/documentos', { params: queryObject }).then(r => {
      setData(r.data)
      swal.close()
    })
  }


  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/documentos');
    document.getElementById('searchForm').reset()
    setCli('')
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'fk_cli':
        setCli(e.target.value);
        break

 
      default:
        auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };

  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Documentação Cliente</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrDatePicker
                value={(filter.data_ini || '').split('T')[0]}
                name="data_ini"
                id="data_ini"
                color="#49573B"
                label="Período"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.data_fim || '').split('T')[0]}
                name="data_fim"
                id="data_fim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrTextInput
                value={filter.fk_cto || ''}
                style={{ width: 330 }}
                name="fk_cto"
                id="fk_cto"
                color="#389492"
                label="Nº Contrato"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <AutoComp
                value={filter.nomecli || ""}
                valor={cli}
                width={400}
                tabela={'clientes'}
                chave={'nome'}
                name="fk_cli"
                id="fk_cli"
                label='Cliente'
                data={comboCli}
                setValue={setCli}
                form={'searchForm'}
                manut={'contratos'}
              />

              <FrSelect
                value={filter.ativo || ''}
                style={{ width: 170 }}
                name="ativo"
                id="ativo"
                label='Ativo'
                data={comboAtivo}
                onChange={handleChange}
              />


            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/salute/documentos/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                    Novo Registro
                  </button>
                </Link>}
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable 
            regName="documentos" 
            columns={columns} 
            searched={filtered} 
            codeName="pk_dcl" 
            page={'Documentos'} 
            data={data} 
            enableEdit={enableEdit} 
            enableDel={enableDel} 
          />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Documentos;
